import { DateConditionEnum } from '@/components/business-components/date-radio'
import VueI18n from 'vue-i18n'

/**
 * Vip详情
 */
export interface ApiVipDetailsResponese {
  vip: number
  number: number
  name: string
  valid_bet: number //累计有效投注
  total_deposit: number //累计充值
  vip_gift: number
  vip_bonus: number
  day_bet: number //日打码(当日还需打码)
  day_deposit: number //日充值(当日还需充值)
  day_bonus: number
  week_bet: number //周打码(当周还需打码)
  week_deposit: number //周充值(当周还需充值)
  week_bonus: number
  month_bet: number //月打码(当月还需打码)
  month_deposit: number //月充值(当月还需充值)
  month_bonus: number
  deposit_channel: number
  personal_server: number
  vip_gift_status: number
  day_bonus_status: number
  week_bonus_status: number
  month_bonus_status: number
  keep_level_bet: number //保级还查打码
  keep_level_deposit: number //保级还查充值
  icon_color?: string
  icon_style?: string
  icon_color_value?: string
}

export interface ApiVipInfoVipSettingsResponese {
  id: number //唯一id
  vip: number //vip等级 (旧字段，保留)
  number: number //vip等级（新字段）
  name: string //等级名称
  valid_bet: number //累计投注
  total_deposit: number //累计充值
  level_up_bet: number //晋级再打码
  level_up_deposit: number //晋级再充值
  last_month_bet: number //保级要求-上月打码
  last_month_deposit: number //保级要求-上月充值
  vip_gift: number //晋级奖励
  day_bet: number //日打码
  day_bonus: number //日奖励
  day_deposit: number //日充值
  week_bonus: number //周奖励
  week_bet: number //周打码
  week_deposit: number //周充值
  month_bet: number //月打码
  month_bonus: number //月奖励
  month_deposit: number //月充值
  icon_color: string //背景
  icon_style: string //颜色
  vip_gift_status: number //晋级奖励领取状态 0=未领取 1=已领取 2=暂不可领取
  week_bonus_status: number //周领取状态 0=未领取 1=已领取 2=暂不可领取
  month_bonus_status: number //月领取状态 0=未领取 1=已领取 2=暂不可领取
  day_bonus_status: number //日领取状态 0=未领取 1=已领取 2=暂不可领取
  maximumDailyWithdrawalAmount: number //每日提现总额上限
  maximumDailyWithdrawalNumber: number //每日提现次数上限
  maximumDailyWithdrawalFreeOfFee: number //每日免手续费笔数
  maximumDailyWithdrawalAmountNew?: string
  maximumDailyWithdrawalNumberNew?: string
  maximumDailyWithdrawalFreeOfFeeNew?: string
  vip_giftNew?: string
  last_month_depositNew?: string
  last_month_betNew?: string
  day_depositNew?: string
  day_betNew?: string
  day_bonusNew?: string
  week_depositNew?: string
  week_betNew?: string
  week_bonusNew?: string
  month_depositNew?: string
  month_betNew?: string
  month_bonusNew?: string
  // 定义是否展示进度条
  level_up_deposit_show_bar?: number | boolean
  next_level_up_deposit_show_bar?: number | boolean
  level_up_bet_show_bar?: number | boolean
  next_level_up_bet_show_bar?: number | boolean
  last_month_deposit_show_bar?: number | boolean
  last_month_bet_show_bar?: number | boolean
  day_deposit_show_bar?: number | boolean
  day_bet_show_bar?: number | boolean
  week_deposit_show_bar?: number | boolean
  week_bet_show_bar?: number | boolean
  month_deposit_show_bar?: number | boolean
  month_bet_show_bar?: number | boolean
}
/**
 * vip等级信息
 */
export interface ApiVipInfoResponese {
  VipSettings?: Array<ApiVipInfoVipSettingsResponese>
  keepLevelStatus?: number //保级开关 0=关闭 1=开启
  VipRule?: string
  weekReceiveDate?: number //周俸禄 0 是本周 其他是上周 这个决定列表表头文案展示‘本周充值’还是‘上周充值’
  monthReceiveDate?: number //月俸禄 0 是本月 其他是上月
}

export enum VipStatus {
  CLOSE = 0,
  OPEN = 1
}
/** vip系统开关 */
export interface ApiVipSwitchStatusResponse {
  currency: string //币种
  status: number //开关 0关 1开
}
/**
 * 用户详情
 */
export interface ApiUserVipDetailsResponse {
  vip_status: number
  vip: number
  number: number
  user_validbet: number
  next_vip: number
  next_vip_validbet: number
  user_deposit: number
  need_deposit: number
  next_vip_deposit: number
  need_validbet: number
  username: string
  nickname: string
  useridx: number
  realname: string
  birthday: string
  weichat: string
  wechat: string
  whatsapp: string
  facebook: string
  telegram: string
  facebook_disable_edit: number
  phone: string
  email: string
  zalo: string
  line: string
  twitter: string
  next_icon_color_value: string
  // 用户的注册日期
  registerTime: string
  background_index: string

  // vip颜色配置
  icon_color_value: string
  icon_color: string
  // 当前vip对应样式1234 0:自定义样式
  current_style: '0' | '1' | '2' | '3' | '4'
  /**是否显示充值 */
  show_deposit: boolean
  /** 是否显示投注 */
  show_valid_bet: boolean
}
/**
 * 真实姓名
 */
export interface ApiUserNameResponse {
  realName?: string
}
/**
 * vip领取载体
 */
export interface ApiVipReceivePayload {
  /** 新的类型(13001=晋级彩金,13002=周奖金,13003=月奖金,13004=日奖金,all一键领取全部) */
  types: string
  vip: number
  logId?: number
}

/**
 * 领取完成返回值
 */
export interface ApiVipReceiveResponse {
  /** 要到这个时间戳才可以领取 */
  receiveTS: number
  game_gold: number
}

/**
 * 领取完成返回值 待领取页面
 */
export interface ApiReceiveResponse {
  userGameGold: number
}

/**
 * 可领取奖励列表返回值
 */
export interface ApiRewardListResponse {
  loading: boolean
  id: number
  useridx: number
  activeName: string
  amount: number
  receiveStatus: number
  checkTime: number
  periodTime: number
  rewardtype: number // 1系统派发 2 用户自领
  rewardType: number // 领取方式
  frontRemark: string // 前台备注
  receiveCallback: () => void
}

export enum ActiveTypeEnum {
  /** 活动 1 */
  Activity = 1,
  /** 任务 2 */
  Task,
  /** 返水 3 */
  Rebate,
  /** 利息宝 4 */
  Interest,
  /** vip奖励 5 */
  Vip,
  /** 公积金 6 */
  RechargeFund
}

export enum LogsCategoryTypeEnum {
  /** 小额 */
  Small = 0,
  /** 大额 */
  Large = 1,
  /** 申请 */
  Apply = 2,
  /** 手动派发 */
  Manual = 3,
  /** 不满足 */
  NotMeet = 4
}

export interface CanReceiveRewardListItem {
  /** 记录id */
  id: number
  /** 旧派发审核奖励ID */
  oldRewardId: number
  /** 活动Id */
  activeId: number
  /** 活动名称 */
  activeName: string
  /** 活动类型 */
  activeType: ActiveTypeEnum
  /** 活动文案 */
  activeTypeText: string
  /** 子类型 */
  template: number
  /** 子类型 名称 */
  templateText: string
  /** 规则Id */
  ruleId: number
  /** 奖励 */
  reward: number
  /** 活跃度 */
  activity: number
  /** 活动日期 活动日期, 时间戳 */
  logCreateTime: number
  /** 领取倒计时，秒数 倒计时，秒数, 正数为可领取倒计时，负数为过期倒计时*/
  receiveDuration: number
  /** 奖励说明 */
  receiveRemark: string
  /** 前台备注 */
  frontRemark: string
  /** 状态 */
  status: number
  /** 领取时间 */
  receiveTime: number
  /** 领取设备类型 */
  receiveDeviceType: string
  /** 奖励大类 （0-小额 1-大额 2-申请 3-手动派发 4-不满足） */
  logsCategory: LogsCategoryTypeEnum
  /** 是否显示小红点：true-是 false-否 */
  isRedDot: boolean
  /** 是否前往：true-是 false-否 （如果为true，按钮显示前往） */
  canGo: boolean
  receiveRemarkJsonFormat: string
  /** 活动分类 */
  categories: string
  /** 过期时间，主要用于区分无限制过期时间 periodTime=0 */
  periodTime: number
  /** 可领取时间 */
  canReceiveTime: number
}

export type receiveRemarkFormat = {
  platform_reward_detail: platformRewardDetailItem[]
}

export type platformRewardDetailItem = {
  game_category_id: number
  game_platform_id: number
  delta_bet_code: number
  rate_id: number
  rate: number
  next_rate_id: number
  next_rate: number
  return_gold: number
  game_category_platform_name: string
}

/**
 * 待奖励列表返回值
 */
export interface ApiCanReceiveRewardListResponse {
  /** 累计奖励 */
  totalReward: number
  /** 累计活跃度 */
  totalActivity: number
  /** 总数 */
  count: number
  /** 列表 */
  list: CanReceiveRewardListItem[]
}

export interface ApiCanReceiveRewardListParams {
  /** 0-今日 1-昨日 7-近7日 15-近15日 30-近30日 60-近60日 */
  timeDay: DateConditionEnum
}

export interface ApiCanReceiveRewardListParamsNew {
  page: number
  pageSize: number
}

/**
 * 单次领取请求参数
 */
export interface ApiSignalReceivePayload {
  id: number
}

/**
 * 奖励-余额宝 列表返回值
 */
export interface ApiYEBRewardResponse {
  id: number
  activeName: VueI18n.TranslateResult
  amount: number
  receiveStatus: number
  loading?: boolean
}
